<template>
  <div>
    <div v-if="showDialog">
      <v-dialog
        v-model="showDialog"
        width="340"
      >
        <v-card>
          <v-card-text class="pa-4">
            <v-layout align-center>
              <div class="panelTitle">
                <span>
                  安全驗證
                </span>
              </div>
              <v-spacer />
              <v-btn
                icon
                class="ma-0"
                @click="showDialog=false"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </v-layout>
            <div class="my-4">
              您正在使用新裝置進行登入，為了您的帳戶安全，請先完成安全驗證。
            </div>
            <div>
              <v-icon class="mr-1">
                person
              </v-icon> 驗證綁定手機：{{ user.cellphone | hidePhone }}
            </div>

            <v-layout class="ma-0 align-start mt-3">
              <v-flex class="mr-2">
                <v-text-field
                  v-model="user.captcha"
                  :rules="[
                    $store.state.validationRules.required,
                    $store.state.validationRules.captcha,
                  ]"
                  :disabled="!sentCaptch"
                  :error="!!errorMessage"
                  :error-messages="errorMessage"
                  single-line
                  label="驗證碼"
                  type="number"
                  class="mt-0 pt-0"
                  prepend-icon="code"
                />
              </v-flex>
              <v-btn
                :disabled="captchaTimer > 0"
                :loading="sendLoading"
                color="info"
                class="mr-0"
                outlined
                small
                @click="sendSignupCaptcha"
              >
                <span v-if="captchaTimer > 0">
                  {{ captchaTimer }} 重新獲取
                </span>
                <span v-else-if="sentCaptch">
                  重發驗證碼
                </span>
                <span v-else>
                  取得驗證碼
                </span>
              </v-btn>
            </v-layout>

            <v-btn
              :disabled="!user.captcha || user.captcha.length !== 6"
              :loading="submitLoading"
              color="info"
              block
              class="subtitle-1 mt-2"
              style="z-index: 1;position: relative;"
              @click="codeLoginSubmit"
            >
              登入
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
      <GetCaptcha ref="GetCaptcha" />
    </div>

    <EventBus
      @onNewDeviceNeedCellphoneCaptcha="onNewDeviceNeedCellphoneCaptcha"
    />
  </div>
</template>
<script>
import GetCaptcha from '@g/components/GetCaptcha'

export default {
  components: {
    GetCaptcha,
  },
  data () {
    return {
      showDialog: false,

      captchaTimer: 0,
      sentCaptch: false,
      sendLoading: false,
      needCatptch: false, // 需要验证码

      user: {
        cellphone: '',
        captcha: ''
      },
      errorMessage: '',
      submitLoading: false,
    }
  },
  mounted () {
    if (!this.$store.state.isPord) {
      // this.showDialog = true
    }
  },
  methods: {
    onNewDeviceNeedCellphoneCaptcha ({ res }) {
      console.log('onNewDeviceNeedCellphoneCaptcha', res)
      if (res.data && res.data.extras && res.data.extras.cellphone) {
        this.user.cellphone = res.data.extras.cellphone
      } else {
        this.user.cellphone = res.config.data.username
      }
      this.showDialog = true
    },
    async sendSignupCaptcha () {
      if (!this.user.cellphone) {
        return
      }
      if (this.$store.state.validationRules.cellphone(this.user.cellphone) !== true) {
        this.$toast('請輸入正確的手機號碼')
        return
      }
      try {
        this.sendLoading = true
        const gRecaptchaResponse = this.needCatptch ? await this.$refs.GetCaptcha.validate() : undefined

        await this.$store.dispatch('user/login/signupSendCaptcha', {
          cellphone: this.user.cellphone,
          gRecaptchaResponse
        }).then(res => {
          if (!res.data.error) {
            this.sentCaptch = true
            this.captchaTimer = 60
            const tiemr = setInterval(() => {
              this.captchaTimer--
              if (this.captchaTimer < 1) {
                clearInterval(tiemr)
                // 重置机器人验证
              }
            }, 1000)
          } else if (res.data.name === 'gRecaptchaResponseEmpty') {
            this.needCatptch = true
          }
        })
      } finally {
        this.sendLoading = false
      }
    },
    userDeleted (model) {
      let deletedImg = ''
      if (model.usermbr.deletedImgs && model.usermbr.deletedImgs.length) {
        deletedImg = this.$options.filters.upyun(model.usermbr.deletedImgs[0])
      }

      this.$router.push({
        name: 'UserDeleted',
        query: {
          deletedImg,
        }
      })
    },
    async codeLoginSubmit () {
      try {
        this.submitLoading = true
        const params = {
          cellphone: this.user.cellphone,
          captcha: this.user.captcha
        }
        const res = await this.$store.dispatch('user/login/signup', params)
        if (!res.data.error) {
          if (res.data.model.status === 404) {
            this.userDeleted(res.data.model)
          } else {
            this.$store.commit('clearKeepAlive')
            setTimeout(() => {
              if (this.$store.state.project === 'mgb-pc') {
                // this.$router.push({ name: 'DgorderCreate' })
                location.reload()
              } else {
                this.$router.replace({ name: 'Home' })
              }
            })
            this.showDialog = false
          }
        } else {
          this.errorMessage = res.data.message || res.data.error
        }
      } finally {
        this.submitLoading = false
      }
    },
  },
}
</script>

<style lang="postcss" scoped>
.panelTitle {
  font-size: 16px;
  font-weight: bold;
  > span {
    border-bottom:2px solid #FF9800;
  }
}
</style>
